import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SkyLayer} from "../aladin-sky-layers-options/aladin-sky-layers-options.component";

@Component({
  selector: 'asax-sky-view-aladin-sky-layers-progress',
  templateUrl: './aladin-sky-layers-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AladinSkyLayersProgressComponent {
  @Input() baseImage: SkyLayer;
  @Input() overlayImage: SkyLayer;
  @Input() alpha: number;
}
